module.exports = flarum.core.compat['admin/utils/saveSettings'];